<template>
    <section class="google-map-wrapper">
        <div id="map">
            <GoogleMap api-key="AIzaSyC_my4aX1ULOXNZcIxmpBnJmVF7U544p2k" style="width: 100%; height: 100%;" :center="center" :zoom="13">
                <Marker :options="{ position: center }" />
            </GoogleMap>
        </div>
    </section>
</template>

<script>
import { GoogleMap, Marker } from "vue3-google-map";

export default {
    name: 'GoogleMapOne',
    components: { GoogleMap, Marker },
    data() {
        return {
            center: {
                lat: 40.689247,
                lng: -74.044502
            }
        }
    }
}
</script>